import { useEffect } from "react";

const useRefreshHubSpotCta = () => {
  useEffect(() => {
    const refreshCTA = () => {
      window.hubspot_web_interactives_running = false;
      const CTArefresh = document.createElement("script");
      CTArefresh.src = "https://js.hubspot.com/web-interactives-embed.js";
      document.body.appendChild(CTArefresh);
    };
    if (window.HubSpotCallsToActions) {
      refreshCTA();
    } else {
      window.hsCallsToActionsReady = [refreshCTA];
    }
  }, []);
};

export default useRefreshHubSpotCta;
